import * as _ from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IObjectResponse } from '@nkr/store/index';
import { IInvoicePayment, ActionsAdminInvoice } from '@nkr/store/billing/actions-admin-invoice';
import DateTimePicker from '@nkr/components/date-time-picker';

interface IProps {
    invoiceId   : number,
    onChange    : () => void
}

interface IStateProps {

}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    addPayment : (payment: IInvoicePayment) => Promise<IObjectResponse<IInvoicePayment>>
}


interface IState {
    invoiceId               : number,
    paymentDate             : string,
    paymentType             : string,
    amount                  : string,
    checkNumber             : number,
    checkNumberReadOnly     : boolean,
    preventNextClick        : boolean
}

type TProps = IProps & IStateProps & IDispatchProps;

class GridInvoiceCollectionsDetailAdd extends React.Component<TProps, IState> {
    readonly state : IState = {
        invoiceId           : null,
        paymentDate         : moment().format("MM/DD/YYYY"),
        paymentType         : 'Payment',
        checkNumber         : null,
        checkNumberReadOnly : false,
        amount              : '',
        preventNextClick    : false  
    }

    addPayment = () => {
        if( this.state.preventNextClick == false ) {
            this.lockOutDoubleClick(true);
           
            let saveValue = {
                id                  : null,
                invoiceId           : this.props.invoiceId,
                paymentDate         : this.state.paymentDate,
                recordedDateTime    : null,
                paymentType         : this.state.paymentType,
                amount              : Number(this.state.amount),
                checkNumber         : Number(this.state.checkNumber)
            } as IInvoicePayment;
    
            this.props.showLoading('Updating Payments...')
                .then(() => {
                    this.props.addPayment(saveValue).then( () => this.props.onChange() );
                })
                .finally(() => {
                    this.props.hideLoading();
                    this.lockOutDoubleClick(false);
                });
        }
    }

    handlePaymentDateChange = (property: string, value: moment.Moment) => {
        let date                            = value.isValid() ? value.format("YYYY-MM-DDT00:00:00") : null;
        this.setState( { paymentDate : date } );
    }

    handlePaymentTypeChange = (e) => {

        if(e.target.value != "Payment")
        {
            this.setState( { checkNumber : null } );
            this.setState( { checkNumberReadOnly : true } );
        }
        else{
            this.setState( { checkNumberReadOnly : false } );
        }

        this.setState( { paymentType : e.target.value } );
    }

    handleAmountChange = (e) => {
        this.setState( { amount : e.target.value } );
    }

    handleCheckNumberChange = (e) => {
        if(e.target.value.length > 12)
            e.target.value = e.target.value.substring(0, 12);
        this.setState( { checkNumber : e.target.value } );
    }

    lockOutDoubleClick = ( turnOnLock : boolean ) => {
        this.setState( { preventNextClick : turnOnLock } );
    }

    render = () => {

        return (
            <tfoot>
                <tr>
                    <td>
                        <DateTimePicker
                            property="paymentDate"
                            dateFormat="MM/DD/YYYY"
                            currentValue={moment(this.state.paymentDate)?.format("MM/DD/YYYY")}
                            onValueChanged={this.handlePaymentDateChange.bind(this)}
                            showTime={false}
                            />
                        </td>
                    <td>
                        <select property='paymentType' className='form-control' onChange={this.handlePaymentTypeChange.bind(this)}>
                        {["Payment","Credit"].map( item => 
                            <option value={item} selected={item == this.state.paymentType}>{item}</option>
                        )}
                        </select>
                    </td>
                    <td>
                        <input property='amount' className='form-control' type='text' value={this.state.amount} onChange={this.handleAmountChange.bind(this)} />
                    </td>
                    <td>
                        <input property='checkNumber' className='form-control' readOnly={this.state.checkNumberReadOnly} type='text' value={this.state.checkNumber} onChange={this.handleCheckNumberChange.bind(this)} />
                    </td>
                    <td>&nbsp;</td>
                    <td><button className='btn btn-primary' onClick={this.addPayment.bind(this)}>Add Payment</button></td>
                </tr>
            </tfoot>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        addPayment: (payment) => { return dispatch(ActionsAdminInvoice.addPayment(payment)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(GridInvoiceCollectionsDetailAdd);